import { useAuth } from '@/contexts/AuthContext';
import BottomNav from './BottomNav';
import DesktopSidebar from './DesktopSidebar';
import PwaInstall from './PwaInstall';

export default function Layout({ children, hideNav = false, className = '' }) {
  const { user } = useAuth();
  const showNav = !hideNav && user && user.role !== 'admin';

  if (!showNav) {
    return (
      <div className="mobile-shell">
        <div className={`mobile-container ${className}`}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <>
      <DesktopSidebar />
      <div className="mobile-shell has-sidebar">
        <div className={`mobile-container ${className}`}>
          <main className="pb-20 md:pb-0">
            {children}
          </main>
          <BottomNav />
          <div className="fixed bottom-24 right-3 z-40 md:hidden">
            <PwaInstall />
          </div>
        </div>
      </div>
    </>
  );
}
